import HsyIframe from '@/components/HsyIframe'

export default function OrganizationSettings() {
  return <HsyIframe pageName={'组织设置'} />
}
import HsyIframe from '@/components/HsyIframe'

export default function OrganizationSettings() {
  return <HsyIframe pageName={'组织设置'} />
}
